/*
        We have quite a bunch redirection logic that we want to keep sepratate.
        This service take care of actual redirection. It mostly required for SaveButtons

 */


const URLService = {

    /*
        This function based on url either redirect to /profile or back to the quote if it was an edit
     */
    redirect_to_home: function() {
        // if quote has an id - return to quote page, otherwise to /profile
        let quoteId = /quotes\/(\d+)\//.exec(window.location.href);
        if (quoteId) {
            this.redirect_to_quote(quoteId[1]);
        } else {
            window.location.replace(window.location.origin + "/profile")
        }
    },

    /* redirect to quote */
    redirect_to_quote: function(quote_id){
        window.location.replace(window.location.origin + "/quotes/"+quote_id);
    },


    /* this one reloads the same page, when we want to build another quote*/
    redirect_to_new_quote_item: function(quote_id){
        //reset the app then set a new quote_id
        window.location.replace(window.location.origin + '/quotes/'+quote_id+'/quote_items/new')
    },

    // this is needed not to erease any data (for Save + Copy) but to change url
    redirect_to_self_change_url: function(quote_id) {
        window.scrollTo(0, 0);
        history.pushState({}, null, window.location.origin + '/quotes/'+quote_id+'/quote_items/new');
    },

    // since we are dealing with both quote items and quotes, this global helper helps us figure out which context are we in
    is_quote_url:function(){
        //if url has quote item in it - it is quote item context
        let quoteItemId = /quote_items/.exec(window.location.href);

        return !quoteItemId
    }

};

export default URLService;